import PropTypes from 'prop-types';
import styles from './LegacyDialogBody.module.scss';

/**
 * ⚠️ TEMPORARY DS-DIALOG MIGRATION SHIM — delete when the legacy popups it wraps
 * are migrated to the real DS `Dialog` sub-components.
 *
 * The DS `<Dialog>` panel is a bare surface: it supplies NO internal padding.
 * That padding is meant to come from `Dialog.Title` / `Dialog.Content` /
 * `Dialog.Actions`. Legacy confirm/cancel popup bodies were migrated from
 * `react-modal` (which padded its content for free) straight into `<Dialog>`
 * without those sub-components, so they render flush against the panel edges.
 * This wrapper restores that lost padding and nothing else.
 *
 * ── TO MIGRATE OUT ─────────────────────────────────────────────────────────
 *   1. Replace `<LegacyDialogBody>…</LegacyDialogBody>` with the real
 *      `Dialog.Title` + `Dialog.Content` + `Dialog.Actions` (and swap the
 *      legacy `<h2>/<button className="btn">` markup for DS `Typography`/`Button`).
 *   2. When no usages remain, delete this whole folder.
 *
 * Find every usage:  grep -rn "LegacyDialogBody" src
 */
export const LegacyDialogBody = ({ children, className }) => (
  <div className={className ? `${styles.body} ${className}` : styles.body}>{children}</div>
);

LegacyDialogBody.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

LegacyDialogBody.defaultProps = {
  className: undefined,
};

export default LegacyDialogBody;
